import React from 'react';
import { Chip } from '@mui/material';
import { ShowStatusBadge } from '../utils/showStatus';

const BADGE_STYLE: Record<Exclude<ShowStatusBadge, null>, { label: string; bgcolor: string }> = {
  preview_opening_day: { label: 'Preview Opening', bgcolor: '#1a4a6e' },
  in_previews: { label: 'Previews', bgcolor: '#2a5878' },
  opening_day: { label: 'Opening Day!', bgcolor: '#2e6b3e' },
  recently_opened: { label: 'Recently Opened', bgcolor: '#3d7a45' },
  closing_day: { label: 'Closing Day', bgcolor: '#6b1a1a' },
  final_week: { label: 'Final Week', bgcolor: '#8b3a28' },
  closing_soon: { label: 'Closing Soon', bgcolor: '#9e5a24' },
};

const ShowStatusBadgeChip: React.FC<{ badge: ShowStatusBadge }> = ({ badge }) => {
  if (!badge) return null;
  const { label, bgcolor } = BADGE_STYLE[badge];
  return (
    <Chip
      label={label}
      size="small"
      sx={{ bgcolor, color: '#fff', fontSize: '0.65rem', height: 18 }}
    />
  );
};

export default ShowStatusBadgeChip;
